import React, {useEffect, useState} from 'react';
import {EnvironmentTemplate} from "../types/EnvironmentTemplate";
import {
    AppHeader, Confirm, DataList,
    DropDownNative, Format, ListItemElement, RoundButton, Searchbox,
    SimpleButton, SquareButton,
    Table,
    TableBody,
    TableBodyCell,
    TableBodyRow
} from "@tag/tag-components-react-v4";
import {
    ABCFilled,
    AddUserFilled,
    Arrow2RightFilled,
    ArrowRightFilled, CircleInfoLined, ClockFilled,
    Database2Filled,
    DeleteFilled, EditFilled, IDFilled,
    IDLined,
    MenuFilled,
    SearchFilled, ServerFilled, ServerLined, UsersFilled,
    WeatherCloudLined
} from "@tag/tag-icons";
import {CustomerDTO} from "../types/CustomerDTO";
import {Customer} from "../types/Customer";
import CustomerService from "../services/CustomerService";
import { ProjectAccents } from "../../General/config/projectAccents";

function TemplateSelector(props: {
    templates: EnvironmentTemplate[],
    setChosenTemplate: Function,
    environmentSelector?: React.ReactNode
}) {
    const [selectedTemplate, setSelectedTemplate] = useState<EnvironmentTemplate>();
    const [displayedTemplates, setDisplayedTemplates] = useState<EnvironmentTemplate[]>();
    const [searchTerm, setSearchTerm] = useState<string>('');
    
    const setTemplateData = (viewAll: boolean, searchTermStr: string) => {
        setSearchTerm(searchTermStr)
        
        if (viewAll) {
            setDisplayedTemplates(props.templates)
            return
        }
        
        if (!searchTermStr) {
            setDisplayedTemplates([]);
            return
        }

        let data = props.templates.filter((n: EnvironmentTemplate) =>
            n.templateName.toLowerCase().includes(searchTermStr.toLowerCase())
        )
        
        if (!data.length) {
            // Horrible, custom logic
            data = props.templates.filter((n: EnvironmentTemplate) =>
                n.templateName.toLowerCase() === 'peopleplanner' || n.templateName.toLowerCase() === 'careblox v2'
            )
        }

        setDisplayedTemplates(data);
    }
    
    const handleSelectButton = (selectedEnvTemplate: EnvironmentTemplate) => {
        setSelectedTemplate(selectedEnvTemplate);
    }
    
    return (
        <>
            <AppHeader
                heading="Search template"
                icon={<SearchFilled />}
                menuItems={[
                    {
                        icon: <UsersFilled />,
                        name: 'all',
                        text: 'View All',
                    },
                ]}
                onMenuItemClick={(e) => {
                    if (e.name === 'all') {
                        setTemplateData(true, '')
                    }
                }}
            >
                <div
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        gap: '1em',
                        justifyContent: 'space-between',
                    }}
                >
                    {props.environmentSelector}
                    <Searchbox
                        onSearch={(str) => {
                            setTemplateData(false, str)
                        }}
                        clearButton
                        style={{ width: '100%' }}
                        value={searchTerm}
                    />
                </div>
            </AppHeader>
            <DataList
                renderSubItemElements={(dataItem) => (
                    <>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <h4>Template:</h4>
                            <ListItemElement
                                icon={<CircleInfoLined accent={ProjectAccents.PeoplePlanner}/>}
                            >
                                Name: {dataItem.templateName}
                            </ListItemElement>
                            <ListItemElement
                                icon={<IDLined accent={ProjectAccents.PeoplePlanner}/>}
                            >
                                Customer: {dataItem.templateCustomerName} ({dataItem.templateCustomerId})
                            </ListItemElement>
                            <ListItemElement
                                icon={<ServerLined accent={ProjectAccents.PeoplePlanner}/>}
                            >
                                AppGrp: {dataItem.templateServerName}
                            </ListItemElement>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '2em', marginRight: '2em' }}>
                            <h4></h4>
                            <ListItemElement
                                icon={<Arrow2RightFilled accent={ProjectAccents.PeoplePlanner}/>}
                            />
                            <ListItemElement
                                icon={<Arrow2RightFilled accent={ProjectAccents.PeoplePlanner}/>}
                            />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <h4>Destination:</h4>
                            <ListItemElement
                                icon={<ServerFilled accent={ProjectAccents.PeoplePlanner}/>}
                            >
                                AppGrp: {dataItem.createOnServerName}
                            </ListItemElement>
                            <ListItemElement
                                icon={<ABCFilled accent={ProjectAccents.PeoplePlanner}/>}
                            >
                                Naming Convention: {dataItem.companyNamingConvention}
                            </ListItemElement>
                        </div>
                    </>
                )}
                renderRightElements={(dataItem) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <SquareButton onClick={() => handleSelectButton(dataItem)} icon={<AddUserFilled />} />
                    </div>
                )}
                data={displayedTemplates ?? []}
            />

            <Confirm
                visible={!!selectedTemplate}
                type="warning"
                accent={ProjectAccents.PeoplePlanner}
                heading={`Please Confirm - Template: ${selectedTemplate?.templateName}`}
                onPrimaryButtonClick={() => {
                    props.setChosenTemplate(selectedTemplate)
                }}
                onCancelButtonClick={() => setSelectedTemplate(undefined)}
                onClose={() => setSelectedTemplate(undefined)}
            >
                Please ensure you have selected the correct template. <strong>We cannot amend this after it is
                created!</strong>
                <br/><br/><br/>
                If you are unsure, please select the 'View All' button on the top right of the search box, or contact
                HSC Care DevOps.
            </Confirm>
        </>
    );
}

export default TemplateSelector;
